import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class OpenOrderDurationAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getOpenOrderDurationTableList', {
            url: '/admin/userPoolRanking/index',
            name: 'list',
            label: '列表'
        }],
        ['exportExcelOpenOrderDurationTableList', {
            url: '/admin/userPoolRanking/exportIndex',
            name: 'export-excel',
            label: '导出'
        }],
        ['searchVenueList', {
            url: '/admin/coupons/shop/list',
            name: 'shop-list',
            label: '店铺列表',
        }],
    ])

    // 开台时长列表
    public getOpenOrderDurationTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getOpenOrderDurationTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // // 导出开台时长记录
    public exportExcelOpenOrderDurationTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('exportExcelOpenOrderDurationTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 搜索店铺列表
    public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('searchVenueList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }
}